import React, { useContext, useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";

import Modal from "react-bootstrap/Modal";

import book_1 from "../../assets/new/images/Feed/book_1.svg";
import book_2 from "../../assets/new/images/Feed/book_2.svg";
import book_3 from "../../assets/new/images/Feed/book_3.svg";
import book_4 from "../../assets/new/images/Feed/book_4.svg";
import book_5 from "../../assets/new/images/Feed/book_5.svg";
import book_6 from "../../assets/new/images/Feed/book_6.svg";
import book_7 from "../../assets/new/images/Feed/book_7.svg";
import book_8 from "../../assets/new/images/Feed/book_8.svg";
import book_9 from "../../assets/new/images/Feed/book_9.svg";

import filter_icon from "../../assets/new/images/filter_icon.svg";

import com_icon from "../../assets/new/images/com.svg";
import like_btn from "../../assets/new/images/uncheckedlike.svg";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../component/Footer";
import { withTranslation } from "react-i18next";
import { HiOutlineDotsVertical } from "react-icons/hi";
import "../../assets/new/css/Forum.css";
import "../../assets/new/css/MyDiary.css";
import "../../assets/new/css/SchoolTvChannel.css";
import "../Feed/Feed.css";
import "../../assets/new/css/communication.css";

import DiaryIcon from "../../assets/new/images/DiaryIcon.svg";
import Sharemodal from "../../assets/new/images/Sharemodel.svg";
import Form from "react-bootstrap/Form";
import add_btn from "../../assets/new/images/Fourms/add_btn.svg";
import dislike_btn from "../../assets/new/images/dislke.png";
import Params from "../../config/Params";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import moment from "moment";
import { BiLike } from "react-icons/bi";
import { BiDislike } from "react-icons/bi";
import { BiSolidDislike } from "react-icons/bi";
import { BiSolidLike } from "react-icons/bi";
import { MdOutlineModeComment } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosClose } from "react-icons/io";
import { io } from "socket.io-client";
import { RiEditBoxFill } from "react-icons/ri";
import SpinnerCmp from "../../component/SpinnerCmp";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa6";
import { BsFiletypePng } from "react-icons/bs";
import BreadCrumbs from "../../component/BreadCrumbs";
import { FaFileVideo } from "react-icons/fa6";
import { FaFileImage } from "react-icons/fa6";
import { FaFileAudio } from "react-icons/fa6";
import authContext from "../../layout/GetUserStatus";

function Fourms() {
  const [show, setShow] = useState(false);
  const [modalShowEdit, setModalShowEdit] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [q, setQ] = useState("");
  const [searchParam] = useState(["title"]);
  const [error, setError] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [show1, setShow1] = useState(false);
  const [forumLists, setForumLists] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [status, setStatus] = useState("");
  const [pageControle, setPageControle] = useState(false);
  const [expanded, setExpanded] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [createMeassage, setCreateMeassage] = useState("");

  const [categoryLists, setCategoryLists] = useState([]);

  const [socket, setSocket] = useState("");
  const [section, setSection] = useState("");
  const [forumId, setForumId] = useState("");
  const [isShownItem, setIsShownItem] = useState("");
  const [isProcessing, setisProcessing] = useState(true);
  const [isCopied, setIsCopied] = useState(false);
  const [isAttached, setIsAttached] = useState("");
  const { t, i18n } = useTranslation();
  const [totalPage, setTotalPage] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [validated, setValidated] = useState(false);
  const dummyForumLists = [
    {
      forum_id: "1",
      forum_title: "Test1",
      forum_description:
        "Learning how to implement infinite scroll with dummy data",
      forum_attachment: "",
      form_book: book_8,
      forum_creator_image: book_1,
      forum_creater: "John Doe",
      forum_created_date: new Date(),
      forum_updated_date: new Date(),
      forum_like_count: 12,
      forum_dislike_count: 2,
      forum_comment_count: 5,
      existing_like: true,
      existing_dislike: false,
      forum_createdby: "123",
    },
    {
      forum_id: "2",
      forum_title: "Test2",
      forum_description: "PDF, Image, and Video file preview in forum cards",
      forum_attachment: "sample.pdf",
      form_book: book_9,
      forum_creator_image: book_2,
      forum_creater: "Jane Smith",
      forum_created_date: new Date(),
      forum_updated_date: new Date(),
      forum_like_count: 8,
      forum_dislike_count: 1,
      forum_comment_count: 3,
      existing_like: false,
      existing_dislike: true,
      forum_createdby: "456",
    },
    {
      forum_id: "3",
      forum_title: "Test3",
      forum_description: "Another dummy forum description goes here.",
      forum_attachment: "image.jpg",
      form_book: book_7,
      forum_creator_image: book_1,
      forum_creater: "Alice Brown",
      forum_created_date: new Date(),
      forum_updated_date: new Date(),
      forum_like_count: 15,
      forum_dislike_count: 0,
      forum_comment_count: 7,
      existing_like: true,
      existing_dislike: false,
      forum_createdby: "789",
    },
    {
      forum_id: "4",
      forum_title: "Test4",
      forum_description: "Discussing dummy forum data and layout structure.",
      forum_attachment: "video.mp4",
      form_book: book_6,
      forum_creator_image: book_2,
      forum_creater: "Robert Taylor",
      forum_created_date: new Date(),
      forum_updated_date: new Date(),
      forum_like_count: 5,
      forum_dislike_count: 2,
      forum_comment_count: 1,
      existing_like: false,
      existing_dislike: true,
      forum_createdby: "321",
    },
    {
      forum_id: "5",
      forum_title: "Test5",
      forum_description: "A sample forum card with all props used.",
      forum_attachment: "",
      form_book: book_4,
      forum_creator_image: book_1,
      forum_creater: "Emily Clark",
      forum_created_date: new Date(),
      forum_updated_date: new Date(),
      forum_like_count: 10,
      forum_dislike_count: 3,
      forum_comment_count: 6,
      existing_like: true,
      existing_dislike: false,
      forum_createdby: "654",
    },
    // Duplicating similar structure to reach 25
    ...Array.from({ length: 20 }, (_, i) => ({
      forum_id: (i + 6).toString(),
      forum_title: `Test${i + 6}`,
      forum_description:
        i % 3 === 0
          ? "Dynamic post showing dummy data for testing."
          : i % 3 === 1
          ? "This forum is used for UI demonstration."
          : "Testing forum interaction and layout.",
      forum_attachment:
        i % 4 === 0
          ? "sample.pdf"
          : i % 4 === 1
          ? "photo.png"
          : i % 4 === 2
          ? "clip.mp4"
          : "",
      form_book: i % 2 === 0 ? book_8 : book_9,
      forum_creator_image: i % 2 === 0 ? book_1 : book_2,
      forum_creater: i % 2 === 0 ? "Dummy User A" : "Dummy User B",
      forum_created_date: new Date(),
      forum_updated_date: new Date(),
      forum_like_count: Math.floor(Math.random() * 20),
      forum_dislike_count: Math.floor(Math.random() * 5),
      forum_comment_count: Math.floor(Math.random() * 10),
      existing_like: i % 2 === 0,
      existing_dislike: i % 3 === 0,
      forum_createdby: i % 2 === 0 ? "999" : "888",
    })),
  ];
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity()) {
      console.log({ title, categoryId, description });
      setModalShow(false);
      handleClear();
    }

    setValidated(true);
  };

  const handleClear = () => {
    setTitle("Sample Forum Title");
    setDescription("This is a sample forum description.");
    setCategoryId("");
    setValidated(false);
  };

  const handleToggle = (index) => {
    setIsExpanded(expanded !== index);
    setExpanded(index);
  };

  const handleIconClick = (index) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  console.log(i18n.language, "gugdugugrugru");

  function search(books) {
    return books.filter((items) => {
      return searchParam.some((newItem) => {
        return (
          items[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
        );
      });
    });
  }
  if (error) {
    return <p>{error.message}</p>;
  } else {
    return (
      <div>
        <div className="page-wrapper compact-wrapper" id="pageWrapper">
          <div className="page-body-wrapper sidebar-icon">
            <div className="page-body" id="container">
              <BreadCrumbs />
              <div class="Forum library">
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="books-main-wrapper">
                        <div className="col-md-12">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <h3 className="headstyle" style={{ flex: 1 }}>
                              {t("Forums")}
                            </h3>
                            <div className="top-btn-wrapper">
                              <button onClick={() => setModalShow(true)}>
                                <img src={add_btn} alt="" />
                                {t("Create Forum")}
                              </button>
                            </div>
                            <img
                              src={filter_icon}
                              alt=""
                              onClick={handleShow}
                            />
                          </div>
                        </div>

                        <div className="my-books">
                          {q === "" ? (
                            ""
                          ) : (
                            <p className="search-result">Search Results</p>
                          )}
                          <InfiniteScroll
                            style={{ overflow: "hidden" }}
                            dataLength={forumLists.length}
                            next={() => {}}
                            hasMore={false}
                          >
                            <div className="row">
                              {dummyForumLists.map((item, index) => (
                                <div
                                  className="col-md-6 col-lg-4 col-sm-12"
                                  key={item.forum_id}
                                >
                                  <div className="cardFeed live-course123">
                                    <div
                                      className="d-flex"
                                      // onClick={navigate("/Forum/ForumView")}
                                    >
                                      {/* Title + Author Info */}
                                      <div className="flex-grow-0">
                                        <img
                                          // width="30%"
                                          // height="50px"
                                          width="65px"
                                          height="60px"
                                          className=" imagesIf "
                                          src={item.form_book}
                                        />
                                      </div>
                                      <Link
                                        className="flex-grow-1"
                                        to={"/Forum/ForumView"}
                                      >
                                        <div className="flex-grow-1">
                                          <p className="route-titles">
                                            {isExpanded && expanded === index
                                              ? item.forum_title
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                item.forum_title.slice(1)
                                              : item.forum_title
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                item.forum_title
                                                  .slice(1)
                                                  .substring(0, 15)}
                                            {item.forum_title.length > 10 && (
                                              <span
                                                onClick={() =>
                                                  handleToggle(index)
                                                }
                                                style={{
                                                  fontSize: "12px",
                                                  color: "gray",
                                                }}
                                              >
                                                {isExpanded &&
                                                expanded === index
                                                  ? t("Read less")
                                                  : t("Read more")}
                                              </span>
                                            )}
                                          </p>
                                          <div
                                            className="d-flex ml-2"
                                            style={{ gap: "10px" }}
                                          >
                                            <img
                                              src={item.forum_creator_image}
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "20px",
                                              }}
                                            />
                                            <p style={{ color: "#5f6166" }}>
                                              {item.forum_creater}
                                            </p>
                                          </div>
                                        </div>
                                      </Link>

                                      {/* Menu Button */}
                                      <div className="app">
                                        <div
                                          className="icon"
                                          onClick={() => handleIconClick(index)}
                                        >
                                          <HiOutlineDotsVertical className="coloricon" />
                                        </div>
                                        <div
                                          className={`dropdown-modal ${
                                            dropdownOpen[index] ? "open" : ""
                                          }`}
                                        >
                                          <div className="mod">
                                            <img src={Sharemodal} alt="" />
                                            <p className="modtxt">
                                              {t("Share")}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Like / Comment / Date */}
                                    <div className="d-flex align-items-center mt-2">
                                      <div className="d-flex align-items-center ml-1">
                                        <div className="like-btn align-items-center">
                                          {item.existing_like ? (
                                            <BiSolidLike
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#ADC927",
                                              }}
                                            />
                                          ) : (
                                            <BiLike
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#758522",
                                              }}
                                            />
                                          )}
                                          <span className="margin-left">
                                            {item.forum_like_count}
                                          </span>
                                        </div>
                                        <div className="dislike-btn align-items-center margin-left">
                                          {item.existing_dislike ? (
                                            <BiSolidDislike
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#ADC927",
                                              }}
                                            />
                                          ) : (
                                            <BiDislike
                                              style={{
                                                width: "15px",
                                                height: "15px",
                                                color: "#758522",
                                              }}
                                            />
                                          )}
                                          <span className="margin-left">
                                            {item.forum_dislike_count}
                                          </span>
                                        </div>
                                        <div className="comments-btn align-items-center margin-left">
                                          {/* <Link
                                            to={`/Forum/ForumView
                                            )}`}
                                          > */}
                                          <MdOutlineModeComment
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              color: "#758522",
                                            }}
                                          />
                                          {/* </Link> */}
                                          <span className="margin-left">
                                            {item.forum_comment_count}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="flex-grow-1">
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <span
                                            className="margin-left"
                                            style={{ color: "#758522" }}
                                          >
                                            {moment(
                                              item.forum_created_date
                                            ).format("YYYY-MM-DD")}{" "}
                                            {moment(
                                              item.forum_updated_date
                                            ).format("hh:mm")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <label className="remain-label">
                                {t("Total Remaining Forums")}
                                &nbsp;{dummyForumLists.length}
                              </label>
                            </div>
                          </InfiniteScroll>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                show={modalShow}
                onHide={() => {
                  setModalShow(false);
                  handleClear();
                }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Form
                  noValidate
                  validated={validated}
                  id="myForm"
                  onSubmit={handleSubmit}
                >
                  <Modal.Header closeButton>
                    <Modal.Title
                      id="contained-modal-title-vcenter border-bottom"
                      className="route-title"
                    >
                      {t("Create Forum")}
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <div className="modal-form-wrapper">
                      <div className="row">
                        <div className="col-md-12 route-title">
                          <Form.Group
                            className="mb-3"
                            controlId="validationCustomTitle"
                          >
                            <Form.Label className="route-title">
                              {t("Title")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={t("Type Your Title Here...")}
                              required
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                              {t("Please provide a title")}.
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                        <div className="col-md-12 route-title">
                          <Form.Group
                            className="mb-3"
                            controlId="validationCustomCategory"
                          >
                            <Form.Label className="route-title">
                              {t("Category")} <span>*</span>
                            </Form.Label>
                            <Form.Select
                              required
                              value={categoryId}
                              onChange={(e) => setCategoryId(e.target.value)}
                            >
                              <option value="">{t("Select")}</option>
                              <option value="1">General</option>
                              <option value="2">Announcements</option>
                              <option value="3">Technical</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {t("Please choose a category")}.
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                        <div className="col-md-12 route-title">
                          <Form.Group
                            className="mb-3"
                            controlId="validationCustomForumText"
                          >
                            <Form.Label className="route-title">
                              {t("Forum Text")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={t("Type Your Text Here...")}
                              required
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                              {t("Please provide forum text")}.
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                        <div className="col-md-12 route-title">
                          <Form.Group
                            className="mb-3"
                            controlId="validationCustomAttachments"
                          >
                            <Form.Label>{t("Attachments")}</Form.Label>
                            <Form.Control type="file" multiple />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <div className="btn-wrapper border-top w-100 d-flex justify-content-end gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          setModalShow(false);
                          handleClear();
                        }}
                        className="cx-btn-1"
                      >
                        {t("Cancel")}
                      </button>
                      <button type="submit" className="cx-btn-2">
                        {t("Publish")}
                      </button>
                    </div>
                  </Modal.Footer>
                </Form>
              </Modal>
              <Modal
                show={show}
                onHide={handleClose}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="common-filter-modal"
              >
                <Modal.Header>
                  <Modal.Title id="contained-modal-title-vcenter">
                    <div className="title-wrapper">
                      <p>{t("Filter By")}</p>
                      <p
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        {t("Clear")}
                      </p>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div class="select-wrapper">
                    <ul>
                      <li>
                        <input
                          type="radio"
                          id="f-option"
                          name="selector"
                          checked={selectedRadio === "f-option"}
                          onChange={() => setSelectedRadio("f-option")}
                        />
                        <label htmlFor="f-option">{t("Most Liked")}</label>
                        <div className="check"></div>
                      </li>

                      <li>
                        <input
                          type="radio"
                          id="s-option"
                          name="selector"
                          checked={selectedRadio === "s-option"}
                          onChange={() => setSelectedRadio("s-option")}
                        />
                        <label htmlFor="s-option">{t("Most UnLiked")}</label>
                        <div className="check">
                          <div className="inside"></div>
                        </div>
                      </li>

                      <li>
                        <input
                          type="radio"
                          id="t-option"
                          name="selector"
                          checked={selectedRadio === "t-option"}
                          onChange={() => setSelectedRadio("t-option")}
                        />
                        <label htmlFor="t-option">{t("Most Commented")}</label>
                        <div className="check">
                          <div className="inside"></div>
                        </div>
                      </li>

                      <li>
                        <input
                          type="radio"
                          id="d-option"
                          name="selector"
                          checked={selectedRadio === "d-option"}
                          onChange={() => setSelectedRadio("d-option")}
                        />
                        <label htmlFor="d-option">{t("My Forum")}</label>
                        <div className="check">
                          <div className="inside"></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    );
  }
}

export default withTranslation()(Fourms);
